/*eslint-disable */
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  Container,
  FormControlLabel,
  Grid,
  List,
  ListItem,
  ListItemText,
  Radio,
  RadioGroup,
  Typography,
  styled,
  useTheme,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import SyncAltIcon from "@mui/icons-material/SyncAlt";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DragDropList from "./DragableList";
import EditIcon from "@mui/icons-material/Edit";
import { GENERATE_BLOG } from "../../gql/mutations/keyword";
import { useMutation } from "@apollo/client";
import DraggableItemsLoader from "../Keywords-dashboard/DraggableItemsLoader";
const SectionWrapper = styled("section")(({ theme }) => ({
  minHeight: "auto",
  display: "flex",
  justifyContent: "center",
  backgroundColor: theme.palette.background.default,
  padding: "0 0 30px",
  "& .SyncIconWrapper": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& svg": {
      color: theme.palette.primary.main,
      width: "70%",
      height: "auto",
    },
    "@media screen and (max-width:768px)": {
      "& svg": {
        transform: "rotate(90deg)",
        width: "30px",
      },
    },
  },
  "& .TopicGenerateBoxTwo": {
    "& .TopicsWrapper": {
      border: "1px solid" + theme.palette.primary.main,
      borderRadius: "10px",
      marginBottom: "15px",
      padding: "13px 18px 14px",
      position: "relative",
      "&:last-of-type": { marginBottom: "0" },
      "& h4": {
        fontSize: "16px",
        fontWeight: 700,
      },
      "& .editIconBox": {
        textAlign: "end",
        marginBottom: "15px",
        "& button": {
          backgroundColor: theme.palette.primary.main,
          color: "#fff",
          "&:hover": {
            backgroundColor: theme.palette.primary.dark,
            color: "#fff",
            "& svg": {
              fill: "#fff",
            },
          },
          "&:focus": {
            outline: "0",
          },
        },
      },
      "& .blogHeadingList": {
        width: "100%",
        maxWidth: 360,
        paddingLeft: "30px",
        backgroundColor: theme.palette.primary.light,
        borderRadius: "6px",
        "@media screen and (max-width:600px)": {
          padding: 0,
        },
        "& li": {
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
      "&  .radioGroup": {
        display: "flex",
        alignItems: "center",
        "& label": {
          marginRight: "3px",
        },
        "& h2": {
          fontSize: "16px",
          fontWeight: 700,
          color: theme.palette.text.primary,
        },
      },
      "& .TopIconBarWrapper": {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
        padding: "0 10px",
        opacity: "0",
        "& .PlusIcon": {
          backgroundColor: theme.palette.background.default,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          "& svg": {
            fontSize: "24px",
            cursor: "pointer",
          },
        },
      },
      "&:hover": {
        "& .TopIconBarWrapper": { opacity: "1" },
      },
    },
  },
  "& .BoxLoaderWrapper": {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.background.default + "9",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  "& .MargeContentWrapper": {
    "& .CopyWrapper": {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      marginBottom: "22px",
      "& p": {
        color: theme.palette.primary.main,
        fontWeight: "600",
      },
    },
    "& .ContentWrapper": {
      marginBottom: "20px",
      "&:last-child": { marginBottom: "0px" },
      "& h2": {
        fontSize: "16px",
        fontWeight: 700,
        marginBottom: "8px",
      },
      "& p": { fontSize: "14px" },
      "& .TabLabelWrapper": {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "10px",
        marginBottom: "35px",
        "& button.MuiTab-root": {
          "&:focus": {
            outline: "none",
          },
        },
        "& .PublishBtnWrapper": {
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: "10px",
        },
      },
    },
  },
}));

function AdvanceOptions({
  setOpen,
  selectedHeading,
  setSelectedHeading,
  formState,
  loading = false,
  advanceSubtopicData = () => null,
  items = [],
  setItems = () => null,
  isDisable = false,
  setIsDisable = () => false,
  setGeneratedItems = () => false,
  isLoading = false,
  content,
}) {
  const theme = useTheme();
  const customizer = useSelector(state => state.customizer);
  const [collapse, setCollapse] = useState(false);
  const [collapseHide, setCollapseHide] = useState(false);
  const [showCompleteContent, setShowCompleteContent] = useState(false);
  const [comLoading, setComLoading] = useState(true);
  const [selectedValue, setSelectedValue] = useState("");
  const [generating, setGenerating] = useState(false);
  const [blog, setBlog] = useState({
    loading: false,
    title: "",
    paragraph: "",
    blogContent: "",
    wordCount: 0,
  });
  const contentRef = useRef(null);
  const [generateBlog] = useMutation(GENERATE_BLOG);
  const handleBlogGenerate = async (index, formState) => {
    setBlog({
      loading: true,
    });
    try {
      await generateBlog({
        variables: {
          input: {
            title: formState?.selectedTitle,
            introduction: formState?.selectedParagraph,
            heading_set: content[index],
          },
        },
        onCompleted: ({ generateAiBlog }) => {
          setBlog({
            title: generateAiBlog.title,
            blogContent: generateAiBlog.content,
            wordCount: generateAiBlog.word_count,
            loading: false,
          });
        },
        onError: errdata => {
          console.log(errdata);
        },
      });
    } catch (e) {
      console.log("error", e);
    }
  };

  const handleRadioChange = async e => {
    const index = e.target.value;
    const selectedItem = content[index];
    setSelectedValue(e.target.value);
    setGenerating(true);
    await handleBlogGenerate(index, formState);
    setGenerating(false);
    setItems([{ id: `${selectedItem[0]}-${Date.now()}`, Topic: selectedItem, index }]);
  };

  const handleCollapse = () => {
    setCollapse(prev => !prev);
    if (collapseHide) {
      setTimeout(() => {
        setCollapseHide(prev => !prev);
      }, 500);
    } else {
      setCollapseHide(prev => !prev);
    }
  };

  const handleCompleteButtonClick = async () => {
    setComLoading(false);
    const topics = items?.map(item => item.Topic).join(",");
    setShowCompleteContent(true);
    scrollToContent();
  };

  const scrollToContent = () => {
    if (contentRef?.current) {
      contentRef?.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleRemoveItem = deleteItem => {
    setItems([]);
    setSelectedValue("");
  };

  const handleOpens = (editHeading, index) => {
    setSelectedHeading({ heading: editHeading, index: index });
    setOpen(true);
  };
  useEffect(() => {
    if (showCompleteContent) {
      scrollToContent();
    }
  }, [showCompleteContent]);

  return (
    <SectionWrapper>
      <Container maxWidth="">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2} mt={0}>
            <Grid item xs={12} md={!collapse ? 7 : 12} sx={{ transition: "all 0.5s ease-in-out" }}>
              <Card
                sx={{
                  padding: { xs: "15px 15px 15px 15px", sm: "25px 25px 25px 25px" },
                  border: `1px solid ${theme.palette.divider}`,
                  height: "100%",
                  position: "relative",
                  boxShadow: "none",
                  minHeight: { xs: "200px", md: "auto" },
                }}
              >
                {blog.loading ? (
                  <DraggableItemsLoader Topic={true} HeadingContent={true} />
                ) : (
                  <DragDropList
                    blog={blog}
                    collapse={collapse}
                    loading={loading}
                    setIsDisable={setIsDisable}
                    handleCollapse={handleCollapse}
                    advanceSubtopicData={advanceSubtopicData}
                    items={items}
                    formState={formState}
                    setItems={setItems}
                    isDisable={isDisable}
                    handleCompleteButtonClick={handleCompleteButtonClick}
                    setGeneratedItems={setGeneratedItems}
                    comLoading={comLoading}
                    handleRemoveItem={handleRemoveItem}
                  />
                )}
              </Card>
            </Grid>
            {!collapseHide && (
              <>
                <Grid item xs={12} md={0.5} sx={{ transition: "all 0.5s ease-in-out" }}>
                  <Box className="SyncIconWrapper">
                    <SyncAltIcon />
                  </Box>
                </Grid>
                <Grid item xs={12} md={4.5} sx={{ transition: "all 0.5s ease-in-out" }}>
                  <Card
                    sx={{
                      padding: { xs: "15px 15px 50px 15px", sm: "25px 25px 25px 25px" },
                      border: `1px solid ${theme.palette.divider}`,
                      height: "100%",
                      position: "relative",
                      boxShadow: "none",
                    }}
                  >
                    {isLoading ? (
                      Array.from({ length: 5 }).map((_, index) => <DraggableItemsLoader key={index} Topic={true} TopicTwo={true} />)
                    ) : (
                      <Box className="TopicGenerateBoxTwo">
                        <RadioGroup value={selectedValue}>
                          {content &&
                            content?.map((item, index) => (
                              <Box className="TopicsWrapper" key={index}>
                                <Box className="editIconBox">
                                  <Button
                                    disabled={generating}
                                    onClick={() => {
                                      handleOpens(item, index);
                                    }}
                                    startIcon={<EditIcon />}
                                    size="small"
                                  >
                                    Edit
                                  </Button>
                                </Box>
                                <Accordion>
                                  <AccordionSummary className="radioGroup" expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
                                    <FormControlLabel disabled={generating} control={<Radio />} value={index} onChange={handleRadioChange} />
                                    <Typography component="h2">{formState?.selectedTitle}</Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <List className="blogHeadingList">
                                      {item &&
                                        item.map((object, key) => {
                                          return (
                                            <ListItem key={key} sx={{ display: "flex", alignItems: "center" }}>
                                              <ListItemText primary={`• ${object}`} />
                                            </ListItem>
                                          );
                                        })}
                                    </List>
                                  </AccordionDetails>
                                </Accordion>
                              </Box>
                            ))}
                        </RadioGroup>
                      </Box>
                    )}
                  </Card>
                </Grid>
              </>
            )}
          </Grid>
        </Box>
      </Container>
    </SectionWrapper>
  );
}

export default AdvanceOptions;
